import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivityView } from '../../../../../views/master-views/app.view/app.view.component';
import { InspectionScheduleActivity } from 'src/app/models/activities/inspection-schedule-activity';
import { FormActivityInputViewComponent } from '../../form-activity-editor/form-activity-input/form-activity-input-view/form-activity-input-view.component';
import { ModalConfirmComponent } from 'src/app/components/system/modal-confirm/modal-confirm.component';
import { InspectionNote, InspectionNoteType } from 'src/app/models';
import { Utilities } from 'src/app/services';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'wm-inspection-schedule-activity-input',
    templateUrl: './inspection-schedule-activity-input.component.html',
    styleUrls: ['./inspection-schedule-activity-input.component.css'],
    standalone: false
})
export class InspectionScheduleActivityInputComponent extends ActivityView
  implements OnInit {
  @ViewChild('formActivityInputView', { static: false })
    formActivityInputViewCtl: FormActivityInputViewComponent; 
  @ViewChild('cancelInspectionModal') cancelInspectionModal: ModalConfirmComponent;
  @ViewChild('bypassInspectionModal') bypassInspectionModal: ModalConfirmComponent;
  
  activity: InspectionScheduleActivity;
  showSchedulerOptions = false;
  cancelReason: InspectionNote;
  bypassReason: InspectionNote;
  cancelForm: UntypedFormGroup;
  bypassForm: UntypedFormGroup;
  cancellingInspection = false;
  bypassingInspection = false;
  requestActivityResponsibleRole: string;
  
  constructor(
    private _fb: UntypedFormBuilder
  ) {
    super();
  }

  ngOnInit() {
    if (this.activity.canCancelInspection || this.activity.canBypassInspection) {
      this.showSchedulerOptions = true;
    }

    this.cancelForm = this._fb.group({});
    this.bypassForm = this._fb.group({});

    this.requestActivityResponsibleRole = 
      this.activity.model.requestActivityResponsibleRole === 'Applicant'
        ? 'Applicant'
        : 'members of the ' + this.activity.model.requestActivityResponsibleRole + 'role';
  }

  async persistChildComponent() {
    return this.formActivityInputViewCtl.persistChildComponent();
  }

  tryCancelInspection() {
    this.cancelForm.addControl(
      'cancelReason',
      new UntypedFormControl('', Validators.required)
    );

    this.cancelReason = new InspectionNote({
      id: Utilities.generateId(),
      type: InspectionNoteType.CancelReason,
      value: null,
      inspectionId: this.activity.model.inspection.id,
      workflowApplicationActivityDataId: this.activity.activityDataId
    });

    this.cancellingInspection = true;

    this.cancelInspectionModal.open();
  }

  abortCancelInspection() {
    this.cancelForm.removeControl('cancelReason');

    this.cancelReason = null;

    this.cancellingInspection = false;
  }
  
  cancelInspection() {
    this.activity.model.isCanceled = true;
    this.activity.model.cancelReason = this.cancelReason;

    this.goNext.emit(true);
  }
  
  tryBypassInspection() {
    this.bypassForm.addControl(
      'bypassReason',
      new UntypedFormControl('', Validators.required)
    );

    this.bypassReason = new InspectionNote({
      id: Utilities.generateId(),
      type: InspectionNoteType.BypassReason,
      value: null,
      inspectionId: this.activity.model.inspection.id,
      workflowApplicationActivityDataId: this.activity.activityDataId
    });

    this.bypassingInspection = true;

    this.bypassInspectionModal.open();
  }

  abortBypassInspection() {
    this.bypassForm.removeControl('bypassReason');

    this.bypassReason = null;

    this.bypassingInspection = false;
  }

  bypassInspection() {
    this.activity.model.isBypassed = true;
    this.activity.model.bypassReason = this.bypassReason;

    this.goNext.emit(true);
  }
}
